export const BASE_PATH = "/analytics";
